import Api from '@/services/Api'

export default {
    getVigencias(){
        return Api().get('subsidiary/vigencias')
    },
    getAllSubsidiaryByComp(id, vigencia){
        return Api().get('subsidiaryByCompany/' + id, {
            params: { vigencia }
        })
    },
    createMatrizSubsi(form){
        return Api().post('subsidiary/asociaMatrizSub', form)
    },
    updateMatrizSubsi(id, form){
        return Api().put('subsidiary/update/' + id, form)
    },
    copyFromPreviousVigencia(form){
        return Api().post('subsidiary/copyFromPrevious', form)
    },
    deleteMatrizSubsi(companyId, subsidiaryId, vigencia){
        return Api().delete(`subsidiary/delete/${companyId}/${subsidiaryId}`, {
            params: { vigencia }
        })
    }
}